var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgFilter = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 18 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#5c6671",
  d: "M16 0H2C.897 0 0 .897 0 2c0 .392.114.771.356 1.139L7 12.537V23.5a.5.5 0 00.854.354l3-3a.498.498 0 00.146-.353v-7.963l6.668-9.436A2.002 2.002 0 0016 0zm.827 2.561l-6.735 9.528a.501.501 0 00-.092.289v7.915l-2 2v-9.915a.499.499 0 00-.092-.289l-6.742-9.54A1 1 0 012 1h14a1 1 0 01.827 1.561z"
})));
export default SvgFilter;